export const MuiCardActionsTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                hasPixelTheme: "true",
                flexWrap: "wrap",
                gap: dt.button.gap,
                justifyContent: "flex-end",
                padding: dt.space.stack.small,
                "&:empty": {
                    display: "none",
                },
            },
        },
    };
};
